"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ProductCategoryDropdownStep_1 = __importDefault(require("../dropdownSteps/ProductCategoryDropdownStep"));
var ProductGroupDropdownStep_1 = __importDefault(require("../dropdownSteps/ProductGroupDropdownStep"));
var ProductDropdownStep_1 = __importDefault(require("../dropdownSteps/ProductDropdownStep"));
var ArticleIdDropdownStep_1 = __importDefault(require("../dropdownSteps/ArticleIdDropdownStep"));
require("../../components/dropdownSteps/_DropdownStep.scss");
var DropdownsContentTab = function () {
    return (react_1.default.createElement("div", { className: "spr-dropdowns-content-tab container" },
        react_1.default.createElement("form", null,
            react_1.default.createElement(ProductCategoryDropdownStep_1.default, null),
            react_1.default.createElement(ProductGroupDropdownStep_1.default, null),
            react_1.default.createElement(ProductDropdownStep_1.default, null),
            react_1.default.createElement(ArticleIdDropdownStep_1.default, null))));
};
DropdownsContentTab.displayName = "Dropdowns Content Tab";
exports.default = DropdownsContentTab;
